import type { EntityRefKind } from "@common/schemas/chatEntityRef.schema";
import {
    NO_ENTITY_REF_OPTIONS,
    type EntityRefOptionsResult,
} from "./entityRefOptions.types";
import { useCounterpartyRefOptions } from "./useCounterpartyRefOptions";
import { useEntityKindRefOptions } from "./useEntityKindRefOptions";
import { useFinancialAccountRefOptions } from "./useFinancialAccountRefOptions";
import { useTaskRefOptions } from "./useTaskRefOptions";

export const ENTITY_REF_EMPTY_COPY: Record<EntityRefKind, string> = {
    financialAccount: "No matching accounts",
    entity: "No matching entities",
    counterparty: "No matching counterparties",
    task: "No matching tasks",
};

/**
 * Options for the active entity kind. Every kind's hook runs on each render
 * so hook order stays fixed; only the active kind does any work.
 */
export function useEntityRefOptions({
    kind,
    query,
}: {
    kind: EntityRefKind | null;
    query: string;
}): EntityRefOptionsResult {
    const financialAccount = useFinancialAccountRefOptions({
        query,
        isEnabled: kind === "financialAccount",
    });
    const entity = useEntityKindRefOptions({
        query,
        isEnabled: kind === "entity",
    });
    const counterparty = useCounterpartyRefOptions({
        query,
        isEnabled: kind === "counterparty",
    });
    const task = useTaskRefOptions({
        query,
        isEnabled: kind === "task",
    });

    switch (kind) {
        case "financialAccount":
            return financialAccount;
        case "entity":
            return entity;
        case "counterparty":
            return counterparty;
        case "task":
            return task;
        default:
            return NO_ENTITY_REF_OPTIONS;
    }
}
